import { fetch } from '../utils/fetch';

/**
 *  查询
 * @returns {Promise<Response>}
 */
export function _queryLocation() {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/location`,
    method: 'get',
  });
}

export default {};
